import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: true,
      text: '',
    },
  },
};

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const data = {
  labels,
  datasets: [
    {
      label: 'Dataset 1',
      data: [0, 19, 15, 20, 30, 40, 40, 50, 25, 30, 50, 70],
      borderColor: 'rgb(100, 182, 98)',
      backgroundColor: 'rgba(100, 182, 98, 0.5)',
    },
    {
      label: 'Dataset 4',
      data: [0, 9, 11, 16, 25, 35, 42, 48, 41, 36, 55, 68],
      borderColor: 'rgb(201, 66, 201)',
      backgroundColor: 'rgba(201, 66, 201, 0.5)',
    },
    {
      label: 'Dataset 2',
      data: [0, 5, 10, 12, 20, 27, 30, 34, 42, 45, 55, 63],
      borderColor: 'rgb(251, 198, 88)',
      backgroundColor: 'rgba(251, 198, 88, 0.5)',
    },
    {
      label: 'Dataset 3',
      data: [0, 5, 8, 10, 18, 22, 25, 30, 40, 40, 50, 60],
      borderColor: 'rgb(255, 166, 176)',
      backgroundColor: 'rgba(172, 192, 117, 0.5)',
    },
  ],
};

export default function App() {
  return <Line options={options} data={data} width={400}
    height={100} />;
}
